import {UseMutationResult, useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export interface GetActiveClassroomRoyalePayload {
  meetingId: string;
  occurenceId: string;
}

export interface ActiveClassroomRoyale {
  room_id: string;
  share_code: string;
  expires_at: string;
  created_by: number;
}

export interface GetActiveClassroomRoyaleResponse {
  success: boolean;
  royale: ActiveClassroomRoyale | null;
  error?: string;
}

export default function useGetActiveClassroomRoyaleApi(
  handleOnSuccess?: (data: GetActiveClassroomRoyaleResponse) => void,
  handleOnError?: (error: unknown) => void,
): UseMutationResult<
  GetActiveClassroomRoyaleResponse,
  unknown,
  GetActiveClassroomRoyalePayload
> {
  return useMutation<
    GetActiveClassroomRoyaleResponse,
    unknown,
    GetActiveClassroomRoyalePayload
  >(
    async (payload: GetActiveClassroomRoyalePayload) => {
      const response = await ChessRestClient.post(
        'classroom/v1/get_active_classroom_puzzle_royale/',
        payload,
      );
      return response.data;
    },
    {
      onSuccess: (data: GetActiveClassroomRoyaleResponse) => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: (error: unknown) => {
        console.error('Failed to fetch active classroom puzzle royale:', error);
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );
}
